import { createApp } from 'vue'
import RatingList from '../../components/ratings/rating-list.vue'

document.addEventListener('DOMContentLoaded', () => {
  const app = createApp(RatingList)
  app.mount('#rating-list')
})